import { atom } from "jotai";

export const isFacebookSDKLoadedAtom = atom(false);
isFacebookSDKLoadedAtom.debugLabel = "Is Facebook SDK Loaded Atom";
